export default __webpack_public_path__ + "static/media/07_photo.f96c00d7.jpeg";